<template>
  <div
    ref="mainRef"
    class="max-w-md"
  >
    <div class="header text-center">
      <div
        class="cursor-pointer absolute left-4 top-3"
        @click="emit('back')"
      >
        <i class="pi pi-chevron-left"></i>
      </div>

      <span class="text-19px leading-24px font-semibold">
        {{ props.package ? _t('package.edit') : _t('package.create') }}
      </span>

      <Icon
        name="close-circle"
        class="cursor-pointer absolute right-4 top-3 w-22px"
        @click="emit('done')"
      ></Icon>
    </div>

    <div class="mt-4">
      <div
        class="text-15px leading-none text-[var(--text-color-secondary)] font-semibold mb-6px"
      >
        {{ _t('package.form_name') }}
      </div>

      <InputText
        v-model="name"
        :pt="{ root: { 'data-focus': 'true' } }"
        class="border-inputBorder bg-inputBg w-full"
        @keydown.enter="onCreatePkg"
      />
    </div>

    <Button
      class="w-full mt-4"
      :label="_t('package.create')"
      :disabled="!isValid"
      :loading="loading"
      @click="onCreatePkg"
    />
  </div>
</template>

<script lang="ts" setup>
import { createPackage } from '@/api/package-source'
import { ref, onMounted, computed } from 'vue'

import type { PackageBasic } from '@/api/package-source'
import type { CardType } from '@/types/model'
import { convertCardTypeToCardName } from '@/shared'

const props = withDefaults(
  defineProps<{
    package?: PackageBasic
    contentTagKey?: string
    cardType: CardType
  }>(),
  {
    package: undefined,
    contentTagKey: undefined,
  }
)

const emit = defineEmits<{
  done: []
  back: []
  update: [PackageBasic]
  create: [PackageBasic]
}>()

const name = ref(props.package?.name ?? '')

const isValid = computed(() => name.value !== '')

const loading = ref(false)

function onCreatePkg(evt?: MouseEvent | KeyboardEvent) {
  if (evt && 'isComposing' in evt && evt.isComposing) return

  if (!isValid.value) return

  loading.value = true

  createPackage(
    name.value.trim(),
    [],
    convertCardTypeToCardName(props.cardType)
  )
    .then(res => {
      if (res.code !== 0) {
        _message.info(res.message)
        return
      }

      _message.success('创建成功')
      emit('create', res.data)
      emit('done')
    })
    .finally(() => {
      loading.value = false
    })
}

// auto focus
const mainRef = ref()
onMounted(() => {
  setTimeout(() => {
    mainRef.value.querySelector('input[data-focus]').focus()
  }, 0)
})
</script>

<style scoped></style>
